import { useEffect, useRef, useCallback } from 'react';

const STORAGE_KEY = 'stx_last_active';
const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];

export function useIdleTimeout({ timeoutMs, onTimeout }) {
  const timerRef    = useRef(null);
  const onTimeoutRef = useRef(onTimeout);

  useEffect(() => { onTimeoutRef.current = onTimeout; }, [onTimeout]);

  const reset = useCallback((writeStorage = true) => {
    clearTimeout(timerRef.current);
    if (writeStorage) localStorage.setItem(STORAGE_KEY, Date.now().toString());
    timerRef.current = setTimeout(() => onTimeoutRef.current(), timeoutMs);
  }, [timeoutMs]);

  useEffect(() => {
    const onActivity = () => reset(true);
    const onStorage  = (e) => { if (e.key === STORAGE_KEY) reset(false); };

    EVENTS.forEach(ev => window.addEventListener(ev, onActivity, { passive: true }));
    window.addEventListener('storage', onStorage);
    reset(true);

    return () => {
      clearTimeout(timerRef.current);
      EVENTS.forEach(ev => window.removeEventListener(ev, onActivity));
      window.removeEventListener('storage', onStorage);
    };
  }, [reset]);
}
